export const handleChangeInputTransPage = (name, value) => ({
    type: 'CHANGE_INPUT_PAGE_TRANS', name, value
});